import { useTopicCategoriesStore } from "../../core/store/topicCategoryStore";
import Logger from "../../utils/Logger";
import { topicCategoryRepository } from "../repositories/topicCategoryRepository";

export const fetchTopicCategoryService = async (
  trainingId: string,
) => {
  if (!trainingId) return;
  const { setTopicCategories } = useTopicCategoriesStore.getState();

  Logger.debug("Fetching topic category...", trainingId);

  const topicCategories = await topicCategoryRepository.getAll(trainingId);

  setTopicCategories(topicCategories);
};
